import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=2b0181ea&scoped=true"
import script from "./Paragraph.vue?vue&type=script&lang=js"
export * from "./Paragraph.vue?vue&type=script&lang=js"
import style0 from "./Paragraph.vue?vue&type=style&index=0&id=2b0181ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0181ea",
  null
  
)

export default component.exports